import { all, put, call, takeEvery, select } from 'redux-saga/effects';
import {
  showLoading,
  hideLoading,
  showPullToRefresh,
  hidePullToRefresh
} from '../../actions/Login/action';
import * as constants from '../../utils/constants';
import request from '../../utils/request';
import { GetMyLoadCardData } from '../../actions/myload/action';
import { getMyloadData } from '../../utils/mock_Data';
import { DomainConverter, GPSWrapper, IONICWrapper, isMobile } from '../../utils/common';
import { buyLoadResponse, buyLoadShipmentResponse } from '../../actions/BookLoad/action';
import {
  loadCarrierData,
  loadAssignedData,
  inTransitData,
  shipmentForStartTrip,
  deliveredData,
  loadDeliveredNeedsPPWKData,
  loadDeliveredWithPPWKData,
  shipmentForStartTripTimestamp,
  deliveredWithPPWKData,
  carrierTenderedData,
  storeMyLoadsFilterCount,
  driverDataforManageUsers
} from '../../actions/carrierAssign/action';
import * as selectors from '../../selectors/Myload/selector';
import { getShipmentParams, getPullToRefreshState } from '../../selectors/selector';
import { checkTimeInterval } from '../App/saga';
import { updateShipmentInfoInOfflineJSON } from '../../actions/App/action';
import { isPlatform } from '@ionic/react';
import { StartTripModel } from '../../models/home/StartTrip.model';
import { ToastMessage } from '../../utils/ToastMessage';
import { acceptLoadData, addReferenceData, pcMillerData } from '../../actions/carrierTendered/action';
import { CONTACT_DETAILS_NOT_FOUND } from '../../utils/constants';

const APPLICATION_JSON_TEXT = 'application/json';
const startTripModel = new StartTripModel();
export function* MyLoadCardDataData() {
  try {
    yield put(showLoading());
    const repos = getMyloadData();
    yield put(GetMyLoadCardData(repos));
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* fetchShipments(data: any) {
  const shipmentParamsSelector = getShipmentParams();
  const shipmentParamsState = yield select(shipmentParamsSelector);
  const pullToRefreshSelector = getPullToRefreshState();
  const pullToRefreshState = yield select(pullToRefreshSelector);
  if (
    shipmentParamsState &&
    checkTimeInterval(
      shipmentParamsState.shipment,
      shipmentParamsState.shipmentInterval
    ) &&
    !pullToRefreshState
  ) {
    return;
  }
  try {
    const { filter } = data.payload.query.query.getShipmentsWithStopsByState.__args;
    if (!(data && data.payload && data.payload.isHideLoader)) {
      yield put(showLoading());
    } else {
      yield put(showPullToRefresh());
    }
    const getShipmentQuery = DomainConverter.domainToData<any>(
      data.payload.query
    );
    const fetchResults = yield call(request, [
      'MYLOAD',
      'CARRIER_WITH_EXPERIENCE',
      null,
      '',
      getShipmentQuery,
      APPLICATION_JSON_TEXT
    ]);
    const results =
      fetchResults?.data?.getShipmentsWithStopsByState;
    const pageNumber = data.payload.query.query.getShipmentsWithStopsByState.__args?.pagination?.pageIndex;
    if (results) {
      yield put(storeMyLoadsFilterCount({
        carrierTenderedFilterCount: results.carrierTenderedFilterCount,
        carrierAssignedFilterCount: results.carrierAssignedFilterCount,
        driverAssignedFilterCount: results.driverAssignedFilterCount,
        inTransitFilterCount: results.inTransitFilterCount,
        deliveredNeedsPaperWorkFilterCount: results.deliveredNeedsPaperWorkFilterCount,
        deliveredWithPaperWorkFilterCount: results.deliveredWithPaperWorkFilterCount
      }))
      if (filter.carrierTendered) {
        yield put(
          carrierTenderedData(results.carrierTenderedShipments || [] , results.carrierTenderedCount, pageNumber)
        );
      }
      if (filter.carrierAssigned) {
        yield put(
          loadCarrierData(
            results.carrierAssginedShipments || [],
            results.carrierAssignedCount,
            pageNumber
          )
        );
      }
      if (filter.driverAssigned) {
        yield put(loadAssignedData(results.driverAssignedShipments|| [], results.driverAssignedCount, pageNumber));
      }
      if (filter.inTransit) {
        yield put(
          inTransitData(results.inTransitShipments|| [] , results.inTransitCount, pageNumber)
        );
      }
      if (filter.delivered) {
        yield put(loadDeliveredNeedsPPWKData( results.deliveredNeedsPaperWorkShipments|| [] , results.deliveredNeedsPaperWorkCount, pageNumber))
      }
      if (filter.deliveredNeedsPaperWork) {
        yield put(loadDeliveredNeedsPPWKData(results.deliveredNeedsPaperWorkShipments || [], results.deliveredNeedsPaperWorkCount, pageNumber))
      }
      if (filter.deliveredWithPaperWork) {
        yield put(loadDeliveredWithPPWKData(results.deliveredWithPaperWorkShipments|| [], results.deliveredWithPaperWorkCount, pageNumber))
      }
      stopGpsTracking(results)
    }
    if (data && data.payload && data.payload.callBack) {
      data.payload.callBack();
    }
    if (!(data && data.payload && data.payload.isHideLoader)) {
      yield put(hideLoading());
    }
    yield put(hidePullToRefresh());
    yield put(
      updateShipmentInfoInOfflineJSON({
        shipment: new Date().toUTCString(),
        shipmentInterval: '5'
      })
    );
  } catch (e) {
    if (!(data && data.payload && data.payload.isHideLoader)) {
      yield put(hideLoading());
    }
    yield put(hidePullToRefresh());
  }
}
export function* fetchShipmentsForDriverInManageUser(data: any) {
  const shipmentParamsSelector = getShipmentParams();
  const shipmentParamsState = yield select(shipmentParamsSelector);
  const pullToRefreshSelector = getPullToRefreshState();
  const pullToRefreshState = yield select(pullToRefreshSelector);
  if (
    shipmentParamsState &&
    checkTimeInterval(
      shipmentParamsState.shipment,
      shipmentParamsState.shipmentInterval
    ) &&
    !pullToRefreshState
  ) {
    return;
  }
  try {
    if (!(data && data.payload && data.payload.isHideLoader)) {
      yield put(showLoading());
    } else {
      yield put(showPullToRefresh());
    }
    const getShipmentQuery = DomainConverter.domainToData<any>(
      data.payload.query
    );
    const fetchResults = yield call(request, [
      'MYLOAD',
      'CARRIER_WITH_EXPERIENCE',
      null,
      '',
      getShipmentQuery,
      APPLICATION_JSON_TEXT
    ]);
    const results =
      fetchResults?.data?.getMyDriverShipments;
      const pageNumber = data.payload.query.query.getMyDriverShipments.__args?.pagination?.pageIndex;
      if (results) {

          yield put(
            driverDataforManageUsers(results.myDriverShipments || [] , results.totalShipmentsCount, pageNumber)
          );
      }
      if (data && data.payload && data.payload.callBack) {
        data.payload.callBack();
      }
      if (!(data && data.payload && data.payload.isHideLoader)) {
        yield put(hideLoading());
      }
      yield put(hidePullToRefresh());
    
  } catch (e) {
    if (!(data && data.payload && data.payload.isHideLoader)) {
      yield put(hideLoading());
    }
    yield put(hidePullToRefresh());
  }
}
export function* acceptDeclineLoad(data: any) {
  try {
    if (!(data && data.payload && data.payload.isHideLoader)) {
      yield put(showLoading());
    }
    const acceptLoadQueryParams = DomainConverter.domainToData<any>(data.payload.query);
    const fetchResults = yield call(request, [
      'MYLOAD',
      'CARRIER_WITH_EXPERIENCE',
      null,
      '',
      acceptLoadQueryParams,
      APPLICATION_JSON_TEXT
    ]);
    const acceptDeclineLoad =
      fetchResults?.data?.tenderAction;
      const errors = fetchResults?.errors;

      if (!errors){
    if (acceptDeclineLoad) {
        yield put(
          acceptLoadData(
            acceptDeclineLoad
          )
        );      
    }
    if (data.callback && acceptDeclineLoad) {
      data.callback(acceptDeclineLoad);
    }
  }
  else if (errors && errors.length > 0 && errors[0].message) {
    isMobile? ToastMessage.show(errors[0].message) : ToastMessage.showWeb(errors[0].message)
  }
  yield put(hideLoading());
  } catch (e) {
      yield put(hideLoading());
  }
}

export function* addReferences(data: any) {
  try {
    if (!(data && data.payload && data.payload.isHideLoader)) {
      yield put(showLoading());
    }
    const failureMessage = IONICWrapper?.details?.keys?.configuration?.AddReferenceFailureMessage;
    const addReferenceQueryParams = DomainConverter.domainToData<any>(data.payload.query);
    const fetchResults = yield call(request, [
      'MYLOAD',
      'CARRIER_WITH_EXPERIENCE',
      null,
      '',
      addReferenceQueryParams,
      APPLICATION_JSON_TEXT
    ]);
    const addReferencesResponse = fetchResults?.data?.addReference;
    const errors = fetchResults?.errors;

    if (!errors) {
      if (addReferencesResponse) {
        yield put(
          addReferenceData(
            addReferencesResponse
          )
        );
      }
      if (data.callback && addReferencesResponse) {
        data.callback(addReferencesResponse);
      }
    }
    else if (errors?.length > 0 && errors[0]?.message) {
      isMobile ? ToastMessage.show(errors[0].message ? failureMessage : errors[0].message) : ToastMessage.showWeb(errors[0].message ? failureMessage : errors[0].message)
    }
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* buyLoadResults(action: any) {
  const { query, data } = action.payload;
  try {
    yield put(showLoading());
    const bookloadRequest = DomainConverter.dataToMutation<any>(query, data);
    const bookloadresponse = yield call(request, [
      'MYLOAD',
      'BUY_LOAD',
      null,
      '',
      bookloadRequest,
      APPLICATION_JSON_TEXT
    ]);
    yield put(buyLoadResponse(bookloadresponse));
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* pcMilerSearchRequest(action: any):any {
  const { query } = action.payload;
  try {
    const pcMilerSearch = yield call(request, [
      'EXPERIENCE',
      'PCMILLER',
      query,
      '',
      null,
      APPLICATION_JSON_TEXT
    ]);
    const pcMilerSearchResponse = pcMilerSearch?.Locations;
    const errors = pcMilerSearchResponse?.Err;
    if (!errors) {
      if (pcMilerSearchResponse) {
        yield put(
          pcMillerData(
            pcMilerSearchResponse
          )
        );
        if (action.callback) {
          action.callback(pcMilerSearchResponse);
        }
      }
    }
    else if (errors?.length > 0 && errors[0]?.message) {
      isMobile ? ToastMessage.show(errors[0].message) : ToastMessage.showWeb(errors[0].message)
    }
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* getShipmentResults(action: any) {
  try {
    if (action && action.payload && action.payload.data.isPullToRefresh) {
      yield put(showPullToRefresh());
    } else {
      yield put(showLoading());
    }
    const mergingGetShipment = (shipmentResponse: any[], selectedBucket: any[]) => {
      if (shipmentResponse?.length > 0) {
        const loadAvailableInBucket: boolean = selectedBucket
          ?.some((obj: any) => obj?.shipmentId ===
            shipmentResponse[0].shipmentId)
        if (loadAvailableInBucket) {
          const loadIndex = selectedBucket?.findIndex((item:any)=>item?.shipmentId ===shipmentResponse[0].shipmentId);
          const currentLoad = {...selectedBucket[loadIndex],...shipmentResponse[0]}
          let updatedBucket = [...selectedBucket]
          if (updatedBucket?.length > 0){
            updatedBucket?.splice(loadIndex, 1,currentLoad); 
            return updatedBucket;
          }
          return selectedBucket;
        } else {
          return shipmentResponse?.concat(selectedBucket
            ?.filter((obj: any) => obj?.shipmentId !== shipmentResponse[0].shipmentId));
        }
      }
      return selectedBucket;
    }
    const getShipmentRequest = DomainConverter.domainToData<any>(
      action.payload.data.query
    );
    const getShipmentResponse = yield call(request, [
      'MYLOAD',
      'CARRIER_WITH_EXPERIENCE',
      null,
      '',
      getShipmentRequest,
      APPLICATION_JSON_TEXT
    ]);
    startTripModel.stopStatus({ status: true, message: "" });
    yield put(buyLoadShipmentResponse(getShipmentResponse));

    const myLoadStore = yield select(selectors.selectData);
    const shipment = (myLoadStore && myLoadStore.shipment) || {};
    const isGlobalSearch = action.payload.data?.isGlobalSearch;
    if (
      action.payload.data.module === constants.MODULES.CARRIER_TENDERED_MODULE
    ) {
      const selectedValue = (myLoadStore && myLoadStore.carrierTendered) || [];
      const res = mergingGetShipment(shipment, selectedValue);
      yield put(carrierTenderedData(res, isGlobalSearch ? myLoadStore?.myLoadCount?.carrierTenderedCount : res.length));
      yield put(shipmentForStartTrip(shipment[0]));
      yield put(shipmentForStartTripTimestamp(new Date().getTime().toString()));
    }
    if (
      action.payload.data.module === constants.MODULES.CARRIER_ASSIGNED_MODULE
    ) {
      const selectedValue = (myLoadStore && myLoadStore.carrierAssigned) || [];
      const res = mergingGetShipment(shipment, selectedValue);
      yield put(loadCarrierData(res, isGlobalSearch ? myLoadStore?.myLoadCount?.carrierAssignedCount : res.length));
      yield put(shipmentForStartTrip(shipment[0]));
      yield put(shipmentForStartTripTimestamp(new Date().getTime().toString()));
    }
    if (
      action.payload.data.module === constants.MODULES.DRIVER_ASSIGNED_MODULE
    ) {
      const selectedValue = (myLoadStore && myLoadStore.driverAssigned) || [];
      const res = mergingGetShipment(shipment, selectedValue);
      yield put(loadAssignedData(res, isGlobalSearch ? myLoadStore?.myLoadCount?.driverAssignedCount : res.length));
      yield put(shipmentForStartTrip(shipment[0]));
      yield put(shipmentForStartTripTimestamp(new Date().getTime().toString()));
    }
    if (action.payload.data.module === constants.MODULES.INTRANSIT_MODULE) {
      const selectedValue = (myLoadStore && myLoadStore.inTransit) || [];
      const res = mergingGetShipment(shipment, selectedValue);
      yield put(inTransitData(res, isGlobalSearch ? myLoadStore?.myLoadCount?.inTransitCount : res.length));
      yield put(shipmentForStartTrip(shipment[0]));
      yield put(shipmentForStartTripTimestamp(new Date().getTime().toString()));
    }
    if (
      action.payload.data.module === constants.MODULES.RECENTLY_DELIVERED_MODULE
    ) {
      const selectedValue = (myLoadStore && myLoadStore.delivered) || [];
      const res = mergingGetShipment(shipment, selectedValue);
      yield put(deliveredData(res, isGlobalSearch ? myLoadStore?.myLoadCount?.deliveredNeedsPaperWorkCount : res.length));
      yield put(shipmentForStartTrip(shipment[0]));
      yield put(shipmentForStartTripTimestamp(new Date().getTime().toString()));
    }
    if (
      action.payload.data.module === constants.MODULES.DELIVERED_WITH_PPWK_MODULE
    ) {
      const selectedValue = (myLoadStore && myLoadStore.delivered) || [];
      const res = mergingGetShipment(shipment, selectedValue);
      yield put(deliveredWithPPWKData(res, isGlobalSearch ? myLoadStore?.myLoadCount?.deliveredWithPaperWorkCount : res.length));
      yield put(shipmentForStartTrip(shipment[0]));
      yield put(shipmentForStartTripTimestamp(new Date().getTime().toString()));
    }
    if (action.payload.callback) {
      action.payload.callback(getShipmentResponse.data);
    }
    if (action && action.payload && action.payload.data.isPullToRefresh) {
      yield put(hidePullToRefresh());
    } else {
      yield put(hideLoading());
    }

    // Stop GPS tracking for unassigned shipmentonly for mobile
    stopGPSpingsForUnassignedLoand(shipment);

  } catch (e) {
    if (action && action.payload && action.payload.data.isPullToRefresh) {
      yield put(hidePullToRefresh());
    } else {
      yield put(hideLoading());
    }
  }
}

// Stop GPS tracking for unassigned shipment only for mobile
function stopGPSpingsForUnassignedLoand(shipments: any) {
  if (isPlatform('capacitor')) {
    GPSWrapper.details.getGPStrackingShipmentID().then((geoShipmentID) => {
      shipments.map((shipment: any, index: any) => {
        if (shipment.shipmentId == geoShipmentID && !shipment.geoTrackingStatus) {
          GPSWrapper.details.stopGPS();
        }
      });
    });
  }
}

export function* getTmsDocuments(action: any) {
  const { query, callback, isLoading = false } = action.payload;
  if (isLoading) { yield put(showLoading()); }
  try {
    const getTmsDocumentsRequest = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      'DOCUMENT',
      'DOCUMENTLIST',
      null,
      '',
      getTmsDocumentsRequest,
      APPLICATION_JSON_TEXT
    ]);
    const listDocuments = response && response.data && response.data.listRelatedDocumentsV2 || null;
    if (isLoading) { yield put(hideLoading()); }
    callback && callback(listDocuments);

  } catch (e) {
    if (isLoading) { yield put(hideLoading()); }
    callback && callback(null);

  }
}

export function* getTmsDocument(action: any) {
  const { query, callback } = action.payload;
  const failureMessage: string =
    (IONICWrapper.details.getKeyValuePairs(constants.CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key) &&
      IONICWrapper.details.getKeyValuePairs(constants.CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key)
        .FETCH_DOCUMENT_CONFIG &&
      IONICWrapper.details.getKeyValuePairs(constants.CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key)
        .FETCH_DOCUMENT_CONFIG.failureMessage) ||
    constants.MYLOAD_DOCUMENT_UPLOAD.FETCH_DOCUMENT_CONFIG.failureMessage
  try {
    yield put(showLoading());
    const getTmsDocumentRequest = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      'DOCUMENT',
      'FETCHDOCUMENT',
      null,
      '',
      getTmsDocumentRequest,
      APPLICATION_JSON_TEXT
    ]);
    const fetchDocument = response && response.data && response.data.fetchDocument || null;
    yield put(hideLoading());
    if (fetchDocument) {
      callback && callback({ ...fetchDocument });
    } else {
      response && response.errors.length > 0 && response.errors.map((error: any) =>
        (isMobile) ? ToastMessage.show(error.message || failureMessage) : ToastMessage.showWeb(error.message || failureMessage)
      )
    }
  } catch (e) {
    yield put(hideLoading());
    callback && callback(null);
  }
}
export function* saveTmsDocuments(action: any) {
  const { query, callback, type } = action.payload;
  try {
    yield put(showLoading());
    const saveTmsDocumentRequest = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      "DOCUMENT",
      "UPLOADDOCUMENT",
      null,
      "",
      saveTmsDocumentRequest,
      APPLICATION_JSON_TEXT
    ]);
    const saveDocument =
      (response && response.data) &&
      (type === constants.CREATE_INVOICE ?
        response.data.createInvoice :
        type === constants.SUBMIT_INVOICE ?
          response.data.uploadInvoice :
          response.data.submitDocument) || null;
    yield put(hideLoading());
    if (saveDocument) {
      callback &&
        callback("success", {
          message: saveDocument.message
        });
    } else {
      const errorMessage: any =
        response &&
        response.errors.length > 0 &&
        response.errors.map((error: any) => error.message).join(", ");
      callback &&
        callback("failed", {
          message: errorMessage
        });
    }
  } catch (e) {
    yield put(hideLoading());
  }
}
export function* saveTmsDocumentsNew(action: any) {
  const { query, callback, type } = action.payload;
  try {
    yield put(showLoading());
    const response = yield call(request, [
      "DOCUMENT",
      type === constants.SUBMIT_INVOICE ? "SUBMIT_INVOICE_NEW" : "UPLOAD_DOCUMENT_NEW",
      null,
      "",
      query,
      APPLICATION_JSON_TEXT
    ]);
    if (response?.createdDateTime) {
      callback &&
        callback("success", {
          message: response?.message
        });
    } else {
      const errorMessage: any =
        response &&
        response?.errors.length > 0 &&
        response?.errors?.map((error: any) => error?.message).join(", ");
      callback &&
        callback("failed", {
          message: errorMessage
        });
    }
  } catch (e) {
    callback &&
        callback("failed");
  } finally {
    yield put(hideLoading());
  }
}

export function* reSendInviteForAssignDriver(action: any) {    
  const { query, callback } = action.payload;
  try {
    yield put(showLoading());
    const reSendInviteresponse = yield call(request, [
      'FETCH_USER_DETAILS',
      'RESEND_INVITE_NOTIFICATION',
      null,
      "",
      query,
      APPLICATION_JSON_TEXT
    ]);
    if (reSendInviteresponse?.success) {
      callback &&
        callback("success", {
          message: reSendInviteresponse?.message,
          success: reSendInviteresponse?.success
        });
    } else {
      const errorMessage: any =
      reSendInviteresponse &&
      reSendInviteresponse?.errors.length > 0 &&
      reSendInviteresponse?.errors?.map((error: any) => error?.message).join(", ");
      callback &&
        callback("failed", {
          message: errorMessage
        });
    }
  } catch (error) {
    callback &&
        callback("failed", {
          message: error.message
        });
  } finally {
    yield put(hideLoading());
  }
}

export function* getContactUsDetails(action: any) :any{
  const { query, callback } = action.payload;
  try {
    yield put(showLoading());
    let contactUsResponse = yield call(request, [
     "MYLOAD",
     "CONTACT_US",
     query,
      '',
      null,
      APPLICATION_JSON_TEXT
    ]);
    if (contactUsResponse?.message !== null) {
      callback &&
        callback("success", {
          message: contactUsResponse?.message,
        });
    }
    else    {
      callback &&
      callback("failed", {
        message: CONTACT_DETAILS_NOT_FOUND
      });
    }
  } catch (error) {
    callback &&
        callback("failed", {
          message: error.message
        });
  }
  finally {
    yield put(hideLoading());
  }
}

const stopGpsTracking = (results: any) => {
  results.driverAssignedShipments && stopGPSpingsForUnassignedLoand(results.driverAssignedShipments);
  results.inTransitShipments && stopGPSpingsForUnassignedLoand(results.inTransitShipments);
  results.deliveredWithPaperWorkShipments && stopGPSpingsForUnassignedLoand(results.deliveredWithPaperWorkShipments);
}

export default function* rootSaga() {
  yield all([
    takeEvery(constants.MYLOAD_CARD_DATA, MyLoadCardDataData),
    takeEvery(constants.SHIPMENT_LOADS, fetchShipments),
    takeEvery(constants.SHIPMENT_LOADS_MANAGE_USER, fetchShipmentsForDriverInManageUser),
    takeEvery(constants.ACCEPT_DECLINE_LOADS, acceptDeclineLoad),
    takeEvery(constants.ADD_REFERENCE, addReferences),    
    takeEvery(constants.PCMILLER_REQUEST, pcMilerSearchRequest),
    takeEvery(constants.BUYLOAD_DATA_REQUEST, buyLoadResults),
    takeEvery(constants.BUYLOAD_SHIPMENT_REQUEST, getShipmentResults),
    takeEvery(constants.GET_TMS_DOCUMENT, getTmsDocument),
    takeEvery(constants.GET_TMS_DOCUMENTS, getTmsDocuments),
    takeEvery(constants.SAVE_TMS_DOCUMENTS, saveTmsDocuments),
    takeEvery(constants.SUBMIT_INVOICE, saveTmsDocuments),
    takeEvery(constants.CREATE_INVOICE, saveTmsDocuments),
    takeEvery(constants.SAVE_TMS_DOCUMENTS_NEW, saveTmsDocumentsNew),
    takeEvery(constants.SUBMIT_INVOICE_NEW, saveTmsDocumentsNew),
    takeEvery(constants.RESEND_INVITE_ASSIGN_DRIVER, reSendInviteForAssignDriver),
    takeEvery(constants.CONTACT_US_DETAILS, getContactUsDetails),
  ]);
}
